import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarTimer = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 7.3335V10.0002L9.33333 10.6668M10.6667 1.3335V2.75201M10.6667 2.75201V4.00016M10.6667 2.75201C10.0393 2.66683 9.21895 2.66683 8 2.66683C6.78105 2.66683 5.96071 2.66683 5.33333 2.75201M10.6667 2.75201C10.9985 2.79707 11.2764 2.86597 11.5307 2.97131C12.5108 3.37729 13.2895 4.15598 13.6955 5.1361C14 5.87118 14 6.80306 14 8.66683C14 10.5306 14 11.4625 13.6955 12.1976C13.2895 13.1777 12.5108 13.9564 11.5307 14.3623C10.7957 14.6668 9.86377 14.6668 8 14.6668C6.13623 14.6668 5.20435 14.6668 4.46927 14.3623C3.48915 13.9564 2.71046 13.1777 2.30448 12.1976C2 11.4625 2 10.5306 2 8.66683C2 6.80306 2 5.87118 2.30448 5.1361C2.71046 4.15598 3.48915 3.37729 4.46927 2.97131C4.72359 2.86597 5.00146 2.79707 5.33333 2.75201M5.33333 1.3335V2.75201M5.33333 2.75201V4.00016",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCalendarTimer);
export default ForwardRef;
